import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["orderSelect", "netAmount", "orderAmounts", "orderAmountsList", "fileInput", "submitButton", "totalAmountOverride", "overrideIndicator", "overrideDisplay"]
  static values = {
    patientId: Number
  }

  connect() {
    this.updateSubmitState()
  }

  formatInputValue(event) {
    const input = event.target
    const value = parseFloat(input.value) || 0
    input.value = value.toFixed(2)
  }

  calculateNetAmount() {
    requestAnimationFrame(() => {
      const orderSelect = this.orderSelectTarget
      if (!orderSelect) return

      const selectedValues = Array.from(orderSelect.selectedOptions || [])
      const orderAmountsList = this.orderAmountsListTarget
      const orderAmountsDiv = this.orderAmountsTarget

      if (selectedValues.length > 0) {
        orderAmountsDiv.style.display = "block"
        orderAmountsList.innerHTML = ""

        selectedValues.forEach((option) => {
          const orderId = option.value
          if (!orderId) return

          const orderText = option.text
          const orderPriceCents = parseInt(option.getAttribute('data-order-price')) || 0
          const remainingCents = parseInt(option.getAttribute('data-remaining-cents')) || 0
          const orderPrice = orderPriceCents / 100
          const remainingPesos = remainingCents / 100

          const textParts = orderText.split(' | ')
          const datePart = textParts.find(part => part.includes('-')) || ''
          const pricePart = textParts.find(part => part.includes('$') && !part.includes('Disponible')) || `$${orderPrice.toFixed(2)}`
          const cleanPrice = `Total: ${pricePart.split(' ')[0]}`
          const availablePart = textParts.find(part => part.includes('Disponible:')) || `Disponible: $${remainingPesos.toFixed(2)}`
          const displayText = `${datePart} | ${cleanPrice} | ${availablePart}`

          const amountDiv = document.createElement("div")
          amountDiv.className = "form-group"
          const inputValue = remainingPesos > 0 ? remainingPesos.toFixed(2) : '0.00'
          amountDiv.innerHTML = `
            <label>${displayText}</label>
            <input type="number"
                   name="invoice[order_amounts][${orderId}]"
                   class="form-control manual-order-amount-input"
                   min="0"
                   max="${remainingPesos.toFixed(2)}"
                   step="0.01"
                   value="${inputValue}"
                   data-order-id="${orderId}"
                   data-order-price="${orderPriceCents}"
                   data-remaining-cents="${remainingCents}"
                   data-action="input->manual-invoice-form#updateTotalAmount blur->manual-invoice-form#formatInputValue">
          `
          orderAmountsList.appendChild(amountDiv)
        })
      } else {
        orderAmountsDiv.style.display = "none"
        orderAmountsList.innerHTML = ""
      }

      this.updateTotalAmount()
      this.updateSubmitState()
    })
  }

  updateTotalAmount() {
    const amountInputs = this.element.querySelectorAll(".manual-order-amount-input")
    let totalPrice = 0

    amountInputs.forEach((input) => {
      const value = parseFloat(input.value) || 0
      totalPrice += value
    })

    if (this.hasNetAmountTarget) {
      this.netAmountTarget.innerHTML = totalPrice.toFixed(2)
    }

    this.updateSubmitState()
  }

  fileChanged() {
    this.updateSubmitState()
  }

  totalOverrideChanged() {
    const overrideValue = this.hasTotalAmountOverrideTarget ? parseFloat(this.totalAmountOverrideTarget.value) : 0

    if (this.hasOverrideIndicatorTarget && this.hasOverrideDisplayTarget) {
      if (overrideValue > 0) {
        this.overrideIndicatorTarget.style.display = "inline"
        this.overrideDisplayTarget.textContent = overrideValue.toFixed(2)
      } else {
        this.overrideIndicatorTarget.style.display = "none"
      }
    }

    this.updateSubmitState()
  }

  updateSubmitState() {
    if (!this.hasSubmitButtonTarget) return

    const hasFile = this.hasFileInputTarget && this.fileInputTarget.files && this.fileInputTarget.files.length > 0
    const hasOrders = this.hasOrderSelectTarget && this.orderSelectTarget.selectedOptions &&
      Array.from(this.orderSelectTarget.selectedOptions).some(opt => opt.value !== '')

    this.submitButtonTarget.disabled = !(hasFile && hasOrders)
  }
}
